/* Custom Swiper Banner — vanilla initialiser for the `custom-swiper-banner` section.
   Expects window.Swiper (Swiper 11) to be loaded globally. */
(function () {
  'use strict';

  var SELECTOR = '.custom-swiper-banner';
  var MAX_RETRIES = 20; // ~5s total when Swiper is slow to arrive
  var RETRY_DELAY = 250;

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function isTrue(value) {
    return value === 'true' || value === '1';
  }

  function initCustomSwiperBanner(sectionEl) {
    if (!sectionEl || sectionEl.dataset.initialized === 'true') return null;
    if (typeof window.Swiper === 'undefined') return null;

    var swiperEl = sectionEl.querySelector('.swiper');
    if (!swiperEl) return null;

    var slides = swiperEl.querySelectorAll('.swiper-slide');
    var slideCount = slides.length;
    if (slideCount === 0) return null;

    var data = sectionEl.dataset;
    var multiple = slideCount > 1;

    var options = {
      speed: parseInt(data.speed, 10) || 600,
      loop: isTrue(data.loop) && multiple,
      watchOverflow: true,
      grabCursor: true,
      a11y: true
    };

    // Autoplay: only with more than one slide, and never with reduced motion.
    if (isTrue(data.autoplay) && multiple && !prefersReducedMotion()) {
      options.autoplay = {
        delay: parseInt(data.delay, 10) || 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: isTrue(data.pauseOnHover)
      };
    }

    var paginationEl = swiperEl.querySelector('.swiper-pagination');
    if (isTrue(data.pagination) && paginationEl) {
      options.pagination = { el: paginationEl, clickable: true };
    }

    var nextEl = swiperEl.querySelector('.swiper-button-next');
    var prevEl = swiperEl.querySelector('.swiper-button-prev');
    if (isTrue(data.arrows) && nextEl && prevEl) {
      options.navigation = { nextEl: nextEl, prevEl: prevEl };
    }

    var instance = new window.Swiper(swiperEl, options);
    sectionEl.__swiper = instance;
    sectionEl.dataset.initialized = 'true';
    return instance;
  }

  function destroyCustomSwiperBanner(sectionEl) {
    if (!sectionEl) return;
    if (sectionEl.__swiper && typeof sectionEl.__swiper.destroy === 'function') {
      sectionEl.__swiper.destroy(true, true);
    }
    sectionEl.__swiper = null;
    delete sectionEl.dataset.initialized;
  }

  function initAll(root) {
    var scope = root || document;
    var banners = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < banners.length; i++) {
      initCustomSwiperBanner(banners[i]);
    }
    return banners.length;
  }

  // Swiper is loaded with `defer` from the layout; retry briefly if it is not ready yet.
  function boot(attempt) {
    if (typeof window.Swiper !== 'undefined') {
      initAll(document);
      return;
    }
    if ((attempt || 0) >= MAX_RETRIES) return;
    window.setTimeout(function () {
      boot((attempt || 0) + 1);
    }, RETRY_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(0);
    });
  } else {
    boot(0);
  }

  // Final safety net once every deferred script has run.
  window.addEventListener('load', function () {
    initAll(document);
  });

  /* ---- Theme editor support ---- */

  function sectionFromEvent(event) {
    var target = event.target;
    if (!target) return null;
    if (target.classList && target.classList.contains('custom-swiper-banner')) return target;
    if (typeof target.querySelector === 'function') {
      var found = target.querySelector(SELECTOR);
      if (found) return found;
    }
    return target.closest ? target.closest(SELECTOR) : null;
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = sectionFromEvent(event);
    if (sectionEl) initCustomSwiperBanner(sectionEl);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionEl = sectionFromEvent(event);
    if (sectionEl) destroyCustomSwiperBanner(sectionEl);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var sectionEl = sectionFromEvent(event);
    if (sectionEl) initCustomSwiperBanner(sectionEl);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var blockEl = event.target;
    if (!blockEl || !blockEl.closest) return;
    var sectionEl = blockEl.closest(SELECTOR);
    if (!sectionEl) return;

    var instance = sectionEl.__swiper || initCustomSwiperBanner(sectionEl);
    if (!instance) return;

    // Pause autoplay while the merchant is editing a slide.
    if (instance.autoplay && instance.autoplay.running) instance.autoplay.stop();

    // In loop mode Swiper reorders the DOM, so prefer its own slide index.
    var index = -1;
    var swiperIndex = blockEl.getAttribute('data-swiper-slide-index');
    if (swiperIndex !== null && swiperIndex !== '') {
      index = parseInt(swiperIndex, 10);
    } else {
      var slides = Array.prototype.slice.call(
        sectionEl.querySelectorAll('.swiper-wrapper > .swiper-slide')
      );
      index = slides.indexOf(blockEl);
    }
    if (isNaN(index) || index < 0) return;

    if (instance.params.loop && typeof instance.slideToLoop === 'function') {
      instance.slideToLoop(index);
    } else {
      instance.slideTo(index);
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var blockEl = event.target;
    if (!blockEl || !blockEl.closest) return;
    var sectionEl = blockEl.closest(SELECTOR);
    if (!sectionEl || !sectionEl.__swiper) return;

    var instance = sectionEl.__swiper;
    if (instance.params.autoplay && instance.params.autoplay.enabled && instance.autoplay) {
      instance.autoplay.start();
    }
  });

  // Exposed for debugging / manual re-init.
  window.initCustomSwiperBanner = initCustomSwiperBanner;
})();
